// extracted by mini-css-extract-plugin
export const container = "photoView-module--container--1ilpo";
export const subContainer = "photoView-module--subContainer--199tL";
export const slide = "photoView-module--slide--2tfFB";